/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMarketHistory} from '../api'

 export const useQueryGetMarketHistory = createReactQueryHook('getMarketHistory', getMarketHistory)
